import { useContext } from "react"
import * as React from "react"
import { Context } from "../../../store/store"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	formElementChanged: Function
	validation: Object
}
const MafoQuestionSix: React.FC<MafoQuestionProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	return (
		<>
			<h3 className="mb-2 text-center font-Alpro  text-[24px] text-blue lg:text-center lg:text-[32px]">Wie bist Du auf die Aktion aufmerksam geworden? (Mehrfach-Antwort möglich)</h3>
			<div className="mx-auto grid grid-cols-1 flex-row text-left lg:max-w-[75%]">
				<ElemCheckboxMafo
					label={<>Werbematerialien im Markt</>}
					props={{
						type: "checkbox",
						name: "question6",
						value: "a",
						onClick: e => formElementChanged(e, "question6"),
					}}
					hasError={validation["invalid_question6"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question6_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Digitale
						Werbestehlen im
						Supermarkt  </>}
					props={{
						type: "checkbox",
						name: "question6",
						value: "b",
						onClick: e => formElementChanged(e, "question6"),
					}}
					hasError={validation["invalid_question6"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question6_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Onpack
						Kommunikation  </>}
					props={{
						type: "checkbox",
						name: "question6",
						value: "c",
						onClick: e => formElementChanged(e, "question6"),
					}}
					hasError={validation["invalid_question6"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question6_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Anzeige im
						Kundenmagazin  </>}
					props={{
						type: "checkbox",
						name: "question6",
						value: "d",
						onClick: e => formElementChanged(e, "question6"),
					}}
					hasError={validation["invalid_question6"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question6_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Social Media  </>}
					props={{
						type: "checkbox",
						name: "question6",
						value: "e",
						onClick: e => formElementChanged(e, "question6"),
					}}
					hasError={validation["invalid_question6"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question6_errMsg"] || ""}
				/>
				<ElemCheckboxMafo
					label={<>Andere</>}
					props={{
						type: "checkbox",
						name: "question6",
						value: "f",
						onClick: e => formElementChanged(e, "question6"),
					}}
					hasError={validation["invalid_question6"] ? true : false}
					className=" pb-2 text-green"
					errMsg={validation["invalid_question6_errMsg"] || ""}
				/>
			</div>
		</>
	)
}

export default MafoQuestionSix
